/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, ContentChild, TemplateRef, ViewChild, ElementRef, HostBinding, HostListener, Component, NgZone, Renderer2, NgModule } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Keys, DraggableModule } from '@progress/kendo-angular-common';
import { validatePackage } from '@progress/kendo-licensing';
import { LocalizationService, L10N_PREFIX } from '@progress/kendo-angular-l10n';
import { CommonModule } from '@angular/common';

/**
 * @hidden
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@progress/kendo-angular-l10n';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@progress/kendo-angular-common';

const _c0 = ["itemWrapper"];
function ScrollViewComponent_li_2_ng_template_1_Template(rf, ctx) { }
const _c1 = function (a0) { return { item: a0 }; };
function ScrollViewComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵtemplate(1, ScrollViewComponent_li_2_ng_template_1_Template, 0, 0, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r1.inlineListItemStyles(i_r4));
    ɵngcc0.ɵɵattribute("aria-hidden", i_r4 !== 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.itemTemplateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c1, item_r3));
} }
function ScrollViewComponent_div_3_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵlistener("click", function ScrollViewComponent_div_3_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r9.leftArrowClick()); });
    ɵngcc0.ɵɵelement(1, "span", 11);
    ɵngcc0.ɵɵelementEnd();
} }
function ScrollViewComponent_div_3_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 12);
    ɵngcc0.ɵɵlistener("click", function ScrollViewComponent_div_3_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r11.rightArrowClick()); });
    ɵngcc0.ɵɵelement(1, "span", 13);
    ɵngcc0.ɵɵelementEnd();
} }
function ScrollViewComponent_div_3_kendo_scrollview_pager_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-scrollview-pager", 14);
    ɵngcc0.ɵɵlistener("pagerIndexChange", function ScrollViewComponent_div_3_kendo_scrollview_pager_3_Template_kendo_scrollview_pager_pagerIndexChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r13.pageChange($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("data", ctx_r8.data)("activeIndex", ctx_r8.activeIndex);
} }
const _c2 = function (a0) { return { "height": a0 }; };
function ScrollViewComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, ScrollViewComponent_div_3_a_1_Template, 2, 0, "a", 7);
    ɵngcc0.ɵɵtemplate(2, ScrollViewComponent_div_3_a_2_Template, 2, 0, "a", 8);
    ɵngcc0.ɵɵtemplate(3, ScrollViewComponent_div_3_kendo_scrollview_pager_3_Template, 1, 2, "kendo-scrollview-pager", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(4, _c2, ctx_r2.height));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.arrows && ctx_r2.displayLeftArrow());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.arrows && ctx_r2.displayRightArrow());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.pageable);
} }
function ScrollViewPagerComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵlistener("click", function ScrollViewPagerComponent_li_1_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const i_r2 = restoredCtx.index; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.indexChange(i_r2)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.itemClass(i_r2));
} }
var Dir;
(function (Dir) {
    Dir[Dir["Next"] = 1] = "Next";
    Dir[Dir["Prev"] = -1] = "Prev";
})(Dir || (Dir = {}));

/**
 * @hidden
 */
const packageMetadata = {
    name: '@progress/kendo-angular-scrollview',
    productName: 'Kendo UI for Angular',
    productCodes: ['KENDOUIANGULAR', 'KENDOUICOMPLETE'],
    publishDate: 1646219224,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-angular-ui/my-license/?utm_medium=product&utm_source=kendoangular&utm_campaign=kendo-ui-angular-purchase-license-keys-warning'
};

/* tslint:disable:use-life-cycle-interface */
/** @hidden */
const iterator = getIterator();
// TODO: Move to kendo-common
function getIterator() {
    if (typeof Symbol === 'function' && Symbol.iterator) {
        return Symbol.iterator;
    }
    const keys = Object.getOwnPropertyNames(Map.prototype);
    const proto = Map.prototype;
    for (let i = 0; i < keys.length; ++i) {
        const key = keys[i];
        if (key !== 'entries' && key !== 'size' && proto[key] === proto.entries) {
            return key;
        }
    }
}
const EMPTY_OBJ = {};
/**
 * @hidden
 */
class DataResultIterator {
    constructor(source, index, endless, pageIndex, rtl) {
        this.rtl = false;
        this.source = source ? source : [];
        this.index = index ? index : 0;
        this.endless = endless;
        this.pageIndex = pageIndex;
        this.rtl = rtl;
    }
    get data() {
        let itemCount = this.total;
        let result;
        if (this.endless) {
            result = [
                this.source[(this.index - 1 + itemCount) % itemCount],
                this.source[this.index % itemCount],
                this.source[(this.index + 1 + itemCount) % itemCount]
            ];
        }
        else {
            const data = [EMPTY_OBJ, ...this.source, EMPTY_OBJ];
            result = data.slice(this.index, this.index + 3);
        }
        if (this.pageIndex !== null) {
            let isForward = this.pageIndex > this.index;
            result[isForward ? 2 : 0] = this.source[this.pageIndex];
        }
        return this.rtl ? result.reverse() : result;
    }
    get total() {
        return this.source.length;
    }
    canMoveNext() {
        return (this.endless || (this.index < this.total - 1));
    }
    canMovePrev() {
        return (this.endless || this.index > 0);
    }
    [iterator]() {
        return this.data[iterator]();
    }
}
/**
 * @hidden
 */
class DataCollection {
    constructor(accessor) {
        this.accessor = accessor;
    }
    get length() { return this.accessor().data.length; }
    get total() { return this.accessor().total; }
    item(index) {
        return this.accessor().data[index];
    }
    canMoveNext() {
        return this.accessor().canMoveNext();
    }
    canMovePrev() {
        return this.accessor().canMovePrev();
    }
    [Symbol.iterator]() {
        return this.accessor()[Symbol.iterator]();
    }
}

/**
 * Represents the [Kendo UI ScrollView component for Angular]({% slug overview_scrollview %}).
 *
 * @example
 * ```ts
 *
 * _@Component({
 *     selector: 'my-app',
 *     template: `
 *       <kendo-scrollview
 *          [data]="items"
 *          [width]="width"
 *          [height]="height"
 *          [endless]="endless"
 *          [pageable]="pageable">
 *         <ng-template let-item="item">
 *           <h2 class="demo-title">{{item.title}}</h2>
 *           <img src='{{item.url}}' alt='{{item.title}}' [ngStyle]="{minWidth: width}" draggable="false" />
 *         </ng-template>
 *       </kendo-scrollview>
 *     `,
 *     styles: [`
 *       .k-scrollview-wrap {
 *         margin: 0 auto;
 *       }
 *       .demo-title {
 *         position: absolute;
 *         top: 0;
 *         left: 0;
 *         right: 0;
 *         margin: 0;
 *         padding: 15px;
 *         color: #fff;
 *         background-color: rgba(0,0,0,.4);
 *         text-align: center;
 *         font-size: 24px;
 *       }
 *     `]
 * })
 *
 * class AppComponent {
 *  public width: string = "600px";
 *  public height: string = "400px";
 *  public endless: boolean = false;
 *  public pageable: boolean = false;
 *  public items: any[] = [
 *       { title: 'Flower', url: 'https://bit.ly/2cJjYuB' },
 *       { title: 'Mountain', url: 'https://bit.ly/2cTBNaL' },
 *       { title: 'Sky', url: 'https://bit.ly/2cJl3Cx' }
 *  ];
 * }
 * ```
 */
let ScrollViewComponent = class ScrollViewComponent {
    constructor(element, localization, ngZone, renderer) {
        this.element = element;
        this.localization = localization;
        this.ngZone = ngZone;
        this.renderer = renderer;
        /**
         * Provides the data source for the ScrollView ([see example]({% slug datasources_scrollview %})).
         */
        this.data = [];
        /**
         * Enables or disables the endless scrolling mode in which the data source items are endlessly looped
         * ([see example]({% slug endlessscrolling_scrollview %})). By default, `endless` is set to `false`
         * and the endless scrolling mode is disabled.
         */
        this.endless = false;
        /**
         * Sets `pagerOverlay` to one of three possible values: `dark`, `light` or `none`.
         * By default, the pager overlay is set to `none`.
         */
        this.pagerOverlay = 'none';
        /**
         * Enables or disables the built-in animations ([see example]({% slug animations_scrollview %})).
         * By default, `animate` is set to `true` and animations are enabled.
         */
        this.animate = true;
        /**
         * Enables or disables the built-in pager ([see example]({% slug paging_scrollview %})).
         * By default, `pageable` is set to `false` and paging is disabled.
         */
        this.pageable = false;
        /**
         * Enables or disables the built-in navigation arrows ([see example]({% slug arrows_scrollview %})).
         * By default, `arrows` is set to `false` and arrows are disabled.
         */
        this.arrows = false;
        /**
         * Fires after the current item is changed.
         */
        this.itemChanged = new EventEmitter();
        /**
         * Fires after the activeIndex has changed. Allows for two-way binding of the activeIndex property.
         */
        this.activeIndexChange = new EventEmitter();
        this.scrollViewClass = true;
        this.tabIndex = 1;
        this.ariaLive = 'assertive';
        this.touchAction = 'pan-y pinch-zoom';
        this.animationState = null;
        this.view = new DataCollection(() => new DataResultIterator(this.data, this.activeIndex, this.endless, this.pageIndex, this.isRTL));
        this.isDataSourceEmpty = false;
        this._activeIndex = 0;
        this.index = 0;
        this.pageIndex = null;
        this.transforms = ['translateX(-100%)', 'translateX(0%)', 'translateX(100%)'];
        validatePackage(packageMetadata);
    }
    /**
     * Represents the current item index ([see example]({% slug activeitems_scrollview %})).
     */
    set activeIndex(value) {
        this.index = this._activeIndex = value;
    }
    get activeIndex() {
        return this._activeIndex;
    }
    get scrollViewLightOverlayClass() {
        return this.pagerOverlay === 'light';
    }
    get scrollViewDarkOverlayClass() {
        return this.pagerOverlay === 'dark';
    }
    get hostWidth() { return this.width; }
    get hostHeight() { return this.height; }
    get dir() {
        return this.direction;
    }
    get direction() {
        return this.localization.rtl ? 'rtl' : 'ltr';
    }
    /**
     * @hidden
     */
    keyDown(e) {
        if (e.keyCode === Keys.ArrowLeft) {
            if (this.isRTL) {
                this.next();
            }
            else {
                this.prev();
            }
        }
        if (e.keyCode === Keys.ArrowRight) {
            if (this.isRTL) {
                this.prev();
            }
            else {
                this.next();
            }
        }
    }
    ngOnChanges(_) {
        this.activeIndex = Math.max(Math.min(this.activeIndex, this.view.total - 1), 0);
    }
    /**
     * Navigates the ScrollView to the previous item.
     */
    prev() {
        this.navigate(Dir.Prev);
    }
    /**
     * Navigates the ScrollView to the next item.
     */
    next() {
        this.navigate(Dir.Next);
    }
    /**
     * @hidden
     */
    transitionEndHandler(e) {
        this.animationState = null;
        if (e.toState === 'left' || e.toState === 'right') {
            if (this.pageIndex !== null) {
                this.activeIndex = this.pageIndex;
                this.pageIndex = null;
            }
            this.activeIndex = this.index;
            this.activeIndexChange.emit(this.activeIndex);
            this.itemChanged.emit({ index: this.activeIndex, item: this.view.item(1) });
        }
    }
    /**
     * @hidden
     */
    handlePress(e) {
        this.initialTouchCoordinate = e.pageX;
    }
    /**
     * @hidden
     */
    handleDrag(e) {
        const deltaX = e.pageX - this.initialTouchCoordinate;
        if (!this.animationState && !this.isDragForbidden(deltaX) && this.draggedInsideBounds(deltaX)) {
            this.renderer.setStyle(this.itemWrapper.nativeElement, 'transform', `translateX(${deltaX}px)`);
        }
    }
    /**
     * @hidden
     */
    handleRelease(e) {
        const deltaX = e.pageX - this.initialTouchCoordinate;
        if (this.isDragForbidden(deltaX)) {
            return;
        }
        this.ngZone.run(() => {
            if (this.draggedEnoughToNavigate(deltaX)) {
                if (this.isRTL) {
                    this.changeIndex(deltaX < 0 ? Dir.Prev : Dir.Next);
                }
                else {
                    this.changeIndex(deltaX > 0 ? Dir.Prev : Dir.Next);
                }
                if (!this.animate) {
                    this.renderer.removeStyle(this.itemWrapper.nativeElement, 'transform');
                    this.activeIndexChange.emit(this.activeIndex);
                    this.itemChanged.emit({ index: this.activeIndex, item: this.view.item(1) });
                }
            }
            else {
                if (this.animate && deltaX) {
                    this.animationState = 'center';
                }
                else {
                    this.renderer.removeStyle(this.itemWrapper.nativeElement, 'transform');
                }
            }
        });
    }
    /**
     * @hidden
     */
    pageChange(idx) {
        if (!this.animationState && this.activeIndex !== idx) {
            if (this.animate) {
                this.pageIndex = idx;
                if (this.isRTL) {
                    this.animationState = (this.pageIndex > this.index ? 'right' : 'left');
                }
                else {
                    this.animationState = (this.pageIndex > this.index ? 'left' : 'right');
                }
            }
            else {
                this.activeIndex = idx;
            }
        }
    }
    /**
     * @hidden
     */
    inlineListItemStyles(idx) {
        return {
            'height': this.height,
            'transform': this.transforms[idx],
            'width': '100%'
        };
    }
    /**
     * @hidden
     */
    displayLeftArrow() {
        let isNotBorderItem;
        if (this.isRTL) {
            isNotBorderItem = this.activeIndex + 1 < this.view.total;
        }
        else {
            isNotBorderItem = this.activeIndex > 0;
        }
        return (this.endless || isNotBorderItem) && this.view.total > 0;
    }
    /**
     * @hidden
     */
    leftArrowClick() {
        if (this.isRTL) {
            this.next();
        }
        else {
            this.prev();
        }
    }
    /**
     * @hidden
     */
    displayRightArrow() {
        let isNotBorderItem;
        if (this.isRTL) {
            isNotBorderItem = this.activeIndex > 0;
        }
        else {
            isNotBorderItem = this.activeIndex + 1 < this.view.total;
        }
        return (this.endless || isNotBorderItem) && this.view.total > 0;
    }
    /**
     * @hidden
     */
    rightArrowClick() {
        if (this.isRTL) {
            this.prev();
        }
        else {
            this.next();
        }
    }
    draggedInsideBounds(deltaX) {
        return Math.abs(deltaX) <= this.element.nativeElement.offsetWidth;
    }
    draggedEnoughToNavigate(deltaX) {
        return Math.abs(deltaX) > (this.element.nativeElement.offsetWidth / 2);
    }
    isDragForbidden(deltaX) {
        let pastEnd;
        let isEndReached;
        if (this.isRTL) {
            pastEnd = deltaX < 0 && deltaX !== 0;
        }
        else {
            pastEnd = deltaX > 0 && deltaX !== 0;
        }
        isEndReached = ((this.activeIndex === 0 && pastEnd) || (this.activeIndex === this.view.total - 1 && !pastEnd));
        return !this.endless && isEndReached;
    }
    navigate(direction) {
        if (this.isDataSourceEmpty || this.animationState) {
            return;
        }
        this.changeIndex(direction);
        if (!this.animate) {
            this.activeIndexChange.emit(this.activeIndex);
            this.itemChanged.emit({ index: this.activeIndex, item: this.view.item(1) });
        }
    }
    changeIndex(direction) {
        if (direction === Dir.Next && this.view.canMoveNext()) {
            this.index = (this.index + 1) % this.view.total;
            if (this.animate) {
                this.animationState = this.isRTL ? 'right' : 'left';
            }
            else {
                this.activeIndex = this.index;
            }
        }
        else if (direction === Dir.Prev && this.view.canMovePrev()) {
            this.index = this.index === 0 ? this.view.total - 1 : this.index - 1;
            if (this.animate) {
                this.animationState = this.isRTL ? 'left' : 'right';
            }
            else {
                this.activeIndex = this.index;
            }
        }
    }
    get isRTL() {
        return this.direction === 'rtl';
    }
};
ScrollViewComponent.ɵfac = function ScrollViewComponent_Factory(t) { return new (t || ScrollViewComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ScrollViewComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ScrollViewComponent, selectors: [["kendo-scrollview"]], contentQueries: function ScrollViewComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.itemTemplateRef = _t.first);
    } }, viewQuery: function ScrollViewComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.itemWrapper = _t.first);
    } }, hostVars: 15, hostBindings: function ScrollViewComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function ScrollViewComponent_keydown_HostBindingHandler($event) { return ctx.keyDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabindex", ctx.tabIndex)("aria-live", ctx.ariaLive)("dir", ctx.dir);
        ɵngcc0.ɵɵstyleProp("touch-action", ctx.touchAction)("width", ctx.hostWidth)("height", ctx.hostHeight);
        ɵngcc0.ɵɵclassProp("k-scrollview", ctx.scrollViewClass)("k-scrollview-light", ctx.scrollViewLightOverlayClass)("k-scrollview-dark", ctx.scrollViewDarkOverlayClass);
    } }, inputs: { data: "data", endless: "endless", pagerOverlay: "pagerOverlay", animate: "animate", pageable: "pageable", arrows: "arrows", activeIndex: "activeIndex", width: "width", height: "height" }, outputs: { itemChanged: "itemChanged", activeIndexChange: "activeIndexChange" }, exportAs: ["kendoScrollView"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.scrollview'
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 3, consts: [["kendoDraggable", "", 1, "k-scrollview-wrap", 3, "kendoDrag", "kendoPress", "kendoRelease"], ["itemWrapper", ""], [3, "ngStyle", 4, "ngFor", "ngForOf"], ["class", "k-scrollview-elements", 3, "ngStyle", 4, "ngIf"], [3, "ngStyle"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "k-scrollview-elements", 3, "ngStyle"], ["class", "k-scrollview-prev", "aria-label", "previous", 3, "click", 4, "ngIf"], ["class", "k-scrollview-next", "aria-label", "next", 3, "click", 4, "ngIf"], ["class", "k-scrollview-nav-wrap", 3, "data", "activeIndex", "pagerIndexChange", 4, "ngIf"], ["aria-label", "previous", 1, "k-scrollview-prev", 3, "click"], [1, "k-icon", "k-i-arrowhead-w"], ["aria-label", "next", 1, "k-scrollview-next", 3, "click"], [1, "k-icon", "k-i-arrowhead-e"], [1, "k-scrollview-nav-wrap", 3, "data", "activeIndex", "pagerIndexChange"]], template: function ScrollViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0, 1);
        ɵngcc0.ɵɵlistener("@animateTo.done", function ScrollViewComponent_Template_ul_animation_animateTo_done_0_listener($event) { return ctx.transitionEndHandler($event); })("kendoDrag", function ScrollViewComponent_Template_ul_kendoDrag_0_listener($event) { return ctx.handleDrag($event); })("kendoPress", function ScrollViewComponent_Template_ul_kendoPress_0_listener($event) { return ctx.handlePress($event); })("kendoRelease", function ScrollViewComponent_Template_ul_kendoRelease_0_listener($event) { return ctx.handleRelease($event); });
        ɵngcc0.ɵɵtemplate(2, ScrollViewComponent_li_2_Template, 2, 6, "li", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, ScrollViewComponent_div_3_Template, 4, 6, "div", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("@animateTo", ctx.animationState);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.view);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isDataSourceEmpty && (ctx.pageable || ctx.arrows));
    } }, dependencies: function () { return [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgStyle, ɵngcc3.DraggableDirective, ScrollViewPagerComponent]; }, encapsulation: 2, data: { animation: [
            trigger('animateTo', [
                state('center, left, right', style({ transform: 'translateX(0)' })),
                transition('* => right', [
                    animate('300ms ease-out', style({ transform: 'translateX(100%)' }))
                ]),
                transition('* => left', [
                    animate('300ms ease-out', style({ transform: 'translateX(-100%)' }))
                ]),
                transition('* => center', [
                    animate('300ms ease-out')
                ])
            ])
        ] } });
__decorate([
    Input(),
    __metadata("design:type", Array)
], ScrollViewComponent.prototype, "data", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ScrollViewComponent.prototype, "activeIndex", null);
__decorate([
    Input(),
    __metadata("design:type", String)
], ScrollViewComponent.prototype, "width", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ScrollViewComponent.prototype, "height", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ScrollViewComponent.prototype, "endless", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ScrollViewComponent.prototype, "pagerOverlay", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ScrollViewComponent.prototype, "animate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ScrollViewComponent.prototype, "pageable", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ScrollViewComponent.prototype, "arrows", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ScrollViewComponent.prototype, "itemChanged", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ScrollViewComponent.prototype, "activeIndexChange", void 0);
__decorate([
    ContentChild(TemplateRef, { static: false }),
    __metadata("design:type", TemplateRef)
], ScrollViewComponent.prototype, "itemTemplateRef", void 0);
__decorate([
    ViewChild('itemWrapper', { static: false }),
    __metadata("design:type", ElementRef)
], ScrollViewComponent.prototype, "itemWrapper", void 0);
__decorate([
    HostBinding('class.k-scrollview'),
    __metadata("design:type", Boolean)
], ScrollViewComponent.prototype, "scrollViewClass", void 0);
__decorate([
    HostBinding('class.k-scrollview-light'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], ScrollViewComponent.prototype, "scrollViewLightOverlayClass", null);
__decorate([
    HostBinding('class.k-scrollview-dark'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], ScrollViewComponent.prototype, "scrollViewDarkOverlayClass", null);
__decorate([
    HostBinding('style.width'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], ScrollViewComponent.prototype, "hostWidth", null);
__decorate([
    HostBinding('style.height'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], ScrollViewComponent.prototype, "hostHeight", null);
__decorate([
    HostBinding('attr.tabindex'),
    __metadata("design:type", Number)
], ScrollViewComponent.prototype, "tabIndex", void 0);
__decorate([
    HostBinding('attr.aria-live'),
    __metadata("design:type", String)
], ScrollViewComponent.prototype, "ariaLive", void 0);
__decorate([
    HostBinding('attr.dir'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], ScrollViewComponent.prototype, "dir", null);
__decorate([
    HostBinding('style.touch-action'),
    __metadata("design:type", String)
], ScrollViewComponent.prototype, "touchAction", void 0);
__decorate([
    HostListener('keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ScrollViewComponent.prototype, "keyDown", null);
ScrollViewComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
        LocalizationService,
        NgZone,
        Renderer2])
], ScrollViewComponent);

/**
 * @hidden
 */
let ScrollViewPagerComponent = class ScrollViewPagerComponent {
    /**
     * @hidden
     */
    constructor() {
        this.pagerIndexChange = new EventEmitter();
    }
    itemClass(idx) {
        return {
            'k-primary': idx === this.activeIndex
        };
    }
    indexChange(selectedIndex) {
        this.pagerIndexChange.emit(selectedIndex);
    }
};
ScrollViewPagerComponent.ɵfac = function ScrollViewPagerComponent_Factory(t) { return new (t || ScrollViewPagerComponent)(); };
ScrollViewPagerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ScrollViewPagerComponent, selectors: [["kendo-scrollview-pager"]], inputs: { activeIndex: "activeIndex", data: "data" }, outputs: { pagerIndexChange: "pagerIndexChange" }, decls: 2, vars: 1, consts: [[1, "k-scrollview-pageable", "k-scrollview-nav"], ["class", "k-button", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "k-button", 3, "ngClass", "click"]], template: function ScrollViewPagerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, ScrollViewPagerComponent_li_1_Template, 1, 1, "li", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.data);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgForOf], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Number)
], ScrollViewPagerComponent.prototype, "activeIndex", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], ScrollViewPagerComponent.prototype, "data", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ScrollViewPagerComponent.prototype, "pagerIndexChange", void 0);

const DECLARATIONS = [
    ScrollViewComponent,
    ScrollViewPagerComponent
];
const EXPORTS = [
    ScrollViewComponent
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the ScrollView component.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the ScrollView module
 * import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, ScrollViewModule], // import ScrollView module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
let ScrollViewModule = class ScrollViewModule {
};
ScrollViewModule.ɵfac = function ScrollViewModule_Factory(t) { return new (t || ScrollViewModule)(); };
ScrollViewModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ScrollViewModule });
ScrollViewModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, DraggableModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollViewComponent, [{
        type: Component,
        args: [{
                animations: [
                    trigger('animateTo', [
                        state('center, left, right', style({ transform: 'translateX(0)' })),
                        transition('* => right', [
                            animate('300ms ease-out', style({ transform: 'translateX(100%)' }))
                        ]),
                        transition('* => left', [
                            animate('300ms ease-out', style({ transform: 'translateX(-100%)' }))
                        ]),
                        transition('* => center', [
                            animate('300ms ease-out')
                        ])
                    ])
                ],
                exportAs: 'kendoScrollView',
                providers: [
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.scrollview'
                    }
                ],
                selector: 'kendo-scrollview',
                template: `
        <ul class='k-scrollview-wrap'
            #itemWrapper
            [@animateTo]="animationState"
            (@animateTo.done)="transitionEndHandler($event)"
            kendoDraggable
            (kendoDrag)="handleDrag($event)"
            (kendoPress)="handlePress($event)"
            (kendoRelease)="handleRelease($event)"
        >
            <li
                *ngFor="let item of view;let i=index"
                [ngStyle]="inlineListItemStyles(i)"
                [attr.aria-hidden]="i !== 1"
            >
                <ng-template
                    [ngTemplateOutlet]="itemTemplateRef"
                    [ngTemplateOutletContext]="{ item: item }">
                </ng-template>
            </li>
      </ul>
        <div class='k-scrollview-elements'
            [ngStyle]="{'height': height}"
            *ngIf="!isDataSourceEmpty && (pageable||arrows)">

            <a class="k-scrollview-prev"
                aria-label="previous"
                *ngIf="arrows && displayLeftArrow()"
                (click)="leftArrowClick()">
                <span class="k-icon k-i-arrowhead-w"></span>
            </a>
            <a class="k-scrollview-next"
                aria-label="next"
                *ngIf="arrows && displayRightArrow()"
                (click)="rightArrowClick()">
                <span class="k-icon k-i-arrowhead-e"></span>
            </a>
            <kendo-scrollview-pager
                class='k-scrollview-nav-wrap'
                *ngIf="pageable"
                (pagerIndexChange)="pageChange($event)"
                [data]="data"
                [activeIndex]="activeIndex">
            </kendo-scrollview-pager>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.LocalizationService }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.Renderer2 }]; }, { data: [{
            type: Input
        }], endless: [{
            type: Input
        }], pagerOverlay: [{
            type: Input
        }], animate: [{
            type: Input
        }], pageable: [{
            type: Input
        }], arrows: [{
            type: Input
        }], itemChanged: [{
            type: Output
        }], activeIndexChange: [{
            type: Output
        }], scrollViewClass: [{
            type: HostBinding,
            args: ['class.k-scrollview']
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], ariaLive: [{
            type: HostBinding,
            args: ['attr.aria-live']
        }], touchAction: [{
            type: HostBinding,
            args: ['style.touch-action']
        }], activeIndex: [{
            type: Input
        }], scrollViewLightOverlayClass: [{
            type: HostBinding,
            args: ['class.k-scrollview-light']
        }], scrollViewDarkOverlayClass: [{
            type: HostBinding,
            args: ['class.k-scrollview-dark']
        }], hostWidth: [{
            type: HostBinding,
            args: ['style.width']
        }], hostHeight: [{
            type: HostBinding,
            args: ['style.height']
        }], dir: [{
            type: HostBinding,
            args: ['attr.dir']
        }], 
    /**
     * @hidden
     */
    keyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], itemTemplateRef: [{
            type: ContentChild,
            args: [TemplateRef, { static: false }]
        }], itemWrapper: [{
            type: ViewChild,
            args: ['itemWrapper', { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollViewPagerComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-scrollview-pager',
                template: `
      <ul class="k-scrollview-pageable k-scrollview-nav">
        <li class="k-button" *ngFor="let item of data; let i = index"
            [ngClass]="itemClass(i)"
            (click)="indexChange(i)">
        </li>
      </ul>
    `
            }]
    }], function () { return []; }, { pagerIndexChange: [{
            type: Output
        }], activeIndex: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollViewModule, [{
        type: NgModule,
        args: [{
                declarations: [DECLARATIONS],
                exports: [EXPORTS],
                imports: [CommonModule, DraggableModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ScrollViewModule, { declarations: function () { return [ScrollViewComponent, ScrollViewPagerComponent]; }, imports: function () { return [CommonModule, DraggableModule]; }, exports: function () { return [ScrollViewComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ScrollViewComponent, ScrollViewModule, ScrollViewPagerComponent };

